/**
 *
 * Button
 *
 */

import React from 'react';
import classnames from 'classnames';
import withStyles from '@fil-react-components/with-styles';
import StreamlineIcon from '@fil-react-components/streamline-icon';

import styles from './BaseButton.style';

export interface Props extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ariaLabel?: string;
  children?: React.ReactNode;
  className?: string;
  block?: boolean;
  small?: boolean;
  fullWidth?: boolean;
  icon?: boolean;
  expanded?: boolean;
  iconSize?: number;
  iconPosition?: 'left' | 'right';
  // @ts-ignore
  svgIcon?: React.ComponentType;
  svgSize?: number;
  smallSvgSize?: number;
  underline?: boolean;
  underlineOnHover?: boolean;
  dark?: boolean;
  // @ts-ignore
  component?: React.ComponentType | 'button';
  isExternal?: boolean;
  target?: string;
  href?: string;
}

/* eslint react/button-has-type: off */
const BaseButton: React.FC<Props> = ({
  ariaLabel,
  className,
  children = 'submit',
  icon,
  iconSize,
  block,
  small,
  fullWidth,
  expanded,
  iconPosition = 'right',
  svgIcon,
  svgSize = 20,
  underline,
  component: Component = 'button',
  smallSvgSize = 16,
  underlineOnHover,
  dark,
  isExternal,
  type = 'button',
  ...extraProps
}) => (
  // @ts-ignore
  <Component
    aria-label={ariaLabel}
    className={classnames(className, 'fil-button inline-flex align-middle align-center')}
    type={type}
    {...extraProps}
  >
    {svgIcon && iconPosition === 'left' && (
      <StreamlineIcon icon={svgIcon} size={small ? smallSvgSize : svgSize} className="mr-8" />
    )}
    {children}
    {svgIcon && iconPosition === 'right' && (
      <StreamlineIcon icon={svgIcon} size={small ? smallSvgSize : svgSize} className="ml-8" />
    )}
  </Component>
);

BaseButton.displayName = 'BaseButton';

const attrs = ({ children }: any) => ({
  icon:
    children &&
    children.type &&
    children.type.displayName &&
    children.type.displayName.indexOf('Icon') > -1,
});

export default withStyles(BaseButton, styles, { attrs });
